import React, { useContext } from 'react';
import { Typography } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { BasketLogicSnackbar } from 'pages/common/components/BasketLogicSnackbar';
import { AddToShoppingList } from '../../components/AddToShoppingList';
import { RoomParams } from '../../components/RoomParams';
import { AddToCart } from '../../components/AddToCart';
import { ProductsList } from '../../components/ProductsList';
import { useSavedProjectsCalculationState } from '../../store/calculation';
import { ServiceBanner } from './components/ServiceBanner';
import {
  FormContainer,
  ParamsHeaderContainer,
  CalculationFormRow,
  CalculationFormColumnLeft,
  CalculationFormColumnRight,
} from './styles';

export const Calculation = () => {
  const { data } = useContext(DataContext);
  const configurationParameters = data?.projectConfigurationParameters;
  useSavedProjectsCalculationState();

  return (
    <FormContainer>
      <ParamsHeaderContainer>
        <Typography variant="h2" color="text-primary" data-testid="saved-calculation-title">
          Сохранённый расчёт
        </Typography>
        {!__IS_SERVER__ ? <AddToShoppingList /> : null}
      </ParamsHeaderContainer>
      <CalculationFormRow>
        <CalculationFormColumnLeft>
          <ProductsList />
          <ServiceBanner />
        </CalculationFormColumnLeft>
        <CalculationFormColumnRight>
          {configurationParameters ? <RoomParams configurationParameters={configurationParameters} /> : null}
          <AddToCart />
        </CalculationFormColumnRight>
      </CalculationFormRow>
      <BasketLogicSnackbar />
    </FormContainer>
  );
};
